import { CSSProperties, useEffect, useState } from 'react'
import Image, { ImageProps } from 'next/legacy/image'
import { buildUrl } from 'cloudinary-build-url'
import { TransformerOption } from '@cld-apis/types'
import { CLOUDINARY_CLOUD_NAME, CLOUDINARY_ENVIRONMENT } from '@/config'

export const defaultBackground = {
  background: 'rgb:090909'
}

interface ICloudinaryImage extends Omit<ImageProps, 'src'> {
  imageId: string
  path: string
  fallbackPath?: string
  fallbackImageId?: string
  memo?: boolean
  style?: CSSProperties
  transformations?: TransformerOption
}

const CloudinaryImage = ({
  alt,
  className = '',
  imageId,
  width,
  height,
  layout,
  objectPosition,
  objectFit,
  path,
  fallbackPath,
  fallbackImageId,
  priority,
  transformations
}: ICloudinaryImage) => {
  const src = buildUrl(`${CLOUDINARY_ENVIRONMENT}/${path}${imageId}`, {
    cloud: { cloudName: CLOUDINARY_CLOUD_NAME },
    transformations: transformations
  })

  const fallbackSrc =
    fallbackPath &&
    fallbackImageId &&
    buildUrl(`${CLOUDINARY_ENVIRONMENT}/${fallbackPath}${fallbackImageId}`, {
      cloud: { cloudName: CLOUDINARY_CLOUD_NAME },
      transformations: transformations
    })

  // https://stackoverflow.com/a/70544058, Eric 2/20/2025
  const [imgSrc, setImgSrc] = useState(src)
  useEffect(() => setImgSrc(src), [src])

  return (
    <Image
      priority={priority}
      className={className}
      width={width}
      height={height}
      layout={layout}
      objectFit={objectFit}
      objectPosition={objectPosition}
      alt={alt}
      src={imgSrc}
      onLoadingComplete={result => {
        if (result.naturalWidth === 0 && !!fallbackSrc) setImgSrc(fallbackSrc)
      }}
      onError={() => {
        if (!!fallbackSrc) setImgSrc(fallbackSrc)
      }}
    />
  )
}

export default CloudinaryImage
